import InputDateRangePicker from './InputDateRangePicker.component';

export default InputDateRangePicker;
